import { InteractivePreview, IsDesignMode } from "./runtimeDetection";

export const DESIGNER_PREVIEW_HEADER = "X-Randol-Designer-Preview";

export function designerRequestOptions(init: RequestInit = {}): RequestInit {
  if (!IsDesignMode && !InteractivePreview.enabled) return init;
  const headers = new Headers(init.headers);
  headers.set(DESIGNER_PREVIEW_HEADER, "true");
  return { ...init, headers, cache: "no-store" };
}
